async function addDraftQuota() {
  showLoading();
  const CREATE_DRAFT_QUOTA_API = window.apiUrl + "/api/draft-quota";
  const customerAccessToken = JSON.parse(
    localStorage.getItem(window.customerAccessTokenKey)
  );
  const accessToken = customerAccessToken
    ? customerAccessToken.accessToken
    : null;
  const addDraftQuoteBtn = document.getElementById("add-draft-quote-btn");

  addDraftQuoteBtn.setAttribute("disabled", true);

  fetch(window.Shopify.routes.root + "cart.js")
    .then((res) => res.json())
    .then(async (cart) => {
      try {
        const items = cart.items.map((item) => {
          return {
            productTitle: item.product_title,
            variantTitle: item.variant_title,
            addonDeliveryDays:
              item.properties && item.properties["Addon Delivery Days"],
            deliveryDays: item.properties && item.properties["Delivery Days"],
            quantity: item.quantity,
            price: parseFloat(item.properties["Final Price"]) || item.price,
            designId: item.properties && item.properties["Design Id"],
          };
        });

        const response = await fetch(CREATE_DRAFT_QUOTA_API, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            customerAccessToken: accessToken,
            items: items,
            firstName: customerFirstName,
            lastName: customerLastName,
            firstNameKata: customerFirstNameKata,
            lastNameKata: customerLastNameKata,
          }),
        });

        if (response.ok) {
          closeLoading();
          // 見積もりサンクスページへリダイレクト
          const thanksPageUrl = '/pages/thanks-quote?from=quote';
          window.location.href = thanksPageUrl;
          
          // 元のモーダル表示処理はコメントアウト
          /*
          const quoteSuccessModal = new bootstrap.Modal(
            document.getElementById("quoteSuccessModal")
          );
          quoteSuccessModal.show();
          */
        } else {
          closeLoading();
          showToast(
            "リクエストは処理されませんでした。後でもう一度お試しください。",
            "error"
          );
        }
      } catch (error) {
        closeLoading();
        showToast(
          "リクエストは処理されませんでした。後でもう一度お試しください。",
          "error"
        );
      } finally {
        closeLoading();
        addDraftQuoteBtn.removeAttribute("disabled");
      }
    });
}

async function updateCustomerMemo(itemKey, memoValue, retryCount = 0) {
  const MAX_RETRIES = 1;
  if (!itemKey || itemKey.toString().trim() === "") {
    return false;
  }

  try {
    const cart = await fetch(window.Shopify.routes.root + "cart.js").then(
      (res) => res.json()
    );

    // Verify item still exists in cart
    const currentItem = cart.items.find((item) => item.key === itemKey);
    if (!currentItem) {
      console.warn("Item not found in cart with key:", itemKey);
      return true; // Item has been deleted, consider as success
    }

    // Prepare updated properties
    const updatedProperties = { ...currentItem.properties };
    updatedProperties["Customer Memo"] = memoValue;

    // Use line item ID instead of line number
    const requestBody = {
      id: currentItem.key,
      properties: updatedProperties,
      quantity: currentItem.quantity,
    };

    const response = await fetch(
      window.Shopify.routes.root + "cart/change.js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      }
    );

    if (response.ok) {
      return true;
    } else {
      // Log detailed error from server
      let errorDetails = `Status: ${response.status}`;
      try {
        const errorData = await response.json();
        if (errorData.errors) {
          errorDetails += `, Errors: ${JSON.stringify(errorData.errors)}`;
        }
        if (errorData.message) {
          errorDetails += `, Message: ${errorData.message}`;
        }
      } catch (e) {
        errorDetails += `, Response Text: ${response.statusText}`;
      }
      // Only retry for network errors, not for business logic errors
      if (retryCount < MAX_RETRIES && response.status >= 500) {
        await new Promise((resolve) => setTimeout(resolve, 300));
        return updateCustomerMemo(itemKey, memoValue, retryCount + 1);
      }

      return false;
    }
  } catch (error) {
    console.error("Error updating customer memo:", error);

    // Only retry for network errors
    if (retryCount < MAX_RETRIES && error.name === "TypeError") {
      await new Promise((resolve) => setTimeout(resolve, 300));
      return updateCustomerMemo(itemKey, memoValue, retryCount + 1);
    }

    return false;
  }
}

/**
 * 明細ごとに、いま表示されている方（PC かスマホ）のメモ入力欄を返す。
 * @returns {HTMLInputElement[]}
 */
function getVisibleMemoInputs() {
  const cartItems = document.querySelectorAll(".cart-item");
  const memoInputs = [];

  // For each cart item, get the appropriate memo input
  for (const cartItem of cartItems) {
    // Check if we're on mobile or desktop by checking which layout is visible
    const desktopLayout = cartItem.querySelector(".cart-item-desktop");
    const mobileLayout = cartItem.querySelector(".cart-item-mobile");

    let memoInput = null;

    // Check which layout is actually visible
    if (desktopLayout && mobileLayout) {
      const desktopStyle = window.getComputedStyle(desktopLayout);

      if (desktopStyle.display !== "none") {
        // Desktop layout is visible
        memoInput = cartItem.querySelector(".item-memo");
      } else {
        // Mobile layout is visible
        memoInput = cartItem.querySelector(".mobile-memo-input");
      }
    } else {
      // Fallback: try desktop first, then mobile
      memoInput =
        cartItem.querySelector(".item-memo") ||
        cartItem.querySelector(".mobile-memo-input");
    }

    if (memoInput) {
      memoInputs.push(memoInput);
    }
  }

  return memoInputs;
}

async function updateAllCustomerMemos() {
  // 画面を開いたときから変わっていないメモは保存済みなので、変わったものだけ cart/change.js で保存する
  const memoInputs = getVisibleMemoInputs().filter(
    (input) => input.value.trim() !== input.defaultValue.trim()
  );

  // If no memos to update, return success
  if (memoInputs.length === 0) {
    return true;
  }

  try {    
    const results = [];
    let successCount = 0;
    let failCount = 0;

    // Process updates sequentially to avoid conflicts
    for (let i = 0; i < memoInputs.length; i++) {
      const input = memoInputs[i];
      const itemKey = getItemKeyFromInput(input);
      const memoValue = input.value.trim() || "";

      if (!itemKey) {
        console.warn(
          `updateAllCustomerMemos: Skipping memo update - invalid item key for input:`,
          input
        );
        continue;
      }

      
      try {
        const result = await updateCustomerMemo(itemKey, memoValue);
        results.push(result);
        
        if (result) {
          successCount++;
        } else {
          failCount++;
          console.error(`updateAllCustomerMemos: Failed to update item ${itemKey}`);
        }
      } catch (error) {
        console.error(`updateAllCustomerMemos: Error updating memo for item ${itemKey}:`, error);
        results.push(false);
        failCount++;
      }
      
      // Add small delay between requests to avoid overwhelming the server
      if (i < memoInputs.length - 1) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }
    }

    // Return true if at least 80% succeed
    const totalProcessed = successCount + failCount;
    if (totalProcessed === 0) {
      return true;
    }

    const successRate = (successCount / totalProcessed) * 100;
    const isSuccess = successRate >= 80;
    
    
    if (!isSuccess) {
      console.warn(`updateAllCustomerMemos: Success rate ${successRate.toFixed(1)}% is below 80% threshold`);
    }

    return isSuccess;
  } catch (error) {
    console.error("Error updating all customer memos:", error);
    return false;
  }
}

/**
 * /api/checkout に送るカートに、画面に入力されているメモを入れる。
 * メモの保存（cart/change.js）に失敗しても、下書き注文にはメモが付くようにするため。
 * 元の cart は書き換えず、新しいオブジェクトを返す。
 * 保存に成功した明細は key が変わって一致しないが、その明細は cart.js 側にメモが入っている。
 * @param {Object} cart - /cart.js の内容
 * @returns {Object}
 */
function withDisplayedMemos(cart) {
  const memoByKey = new Map();
  getVisibleMemoInputs().forEach((input) => {
    const itemKey = getItemKeyFromInput(input);
    if (itemKey) {
      memoByKey.set(itemKey, input.value.trim());
    }
  });

  return {
    ...cart,
    items: cart.items.map((item) =>
      memoByKey.has(item.key)
        ? {
            ...item,
            properties: {
              ...(item.properties || {}),
              "Customer Memo": memoByKey.get(item.key),
            },
          }
        : item
    ),
  };
}

function getItemKeyFromInput(input) {
  if (!input) {
    console.warn("getItemKeyFromInput: input element is null or undefined");
    return null;
  }

  const cartItem = input.closest(".cart-item");
  if (!cartItem) {
    console.warn(
      "getItemKeyFromInput: could not find .cart-item parent for input:",
      input
    );
    return null;
  }

  // Get item key from data attribute
  const itemKey = cartItem.getAttribute("data-item-key");
  if (!itemKey) {
    console.warn("getItemKeyFromInput: could not find data-item-key attribute");
    return null;
  }

  return itemKey;
}

/**
 * Calculate total cart amount based on Final Price property
 * @param {Object} cart - Shopify cart object
 * @returns {number} - Total amount in yen (not cents)
 */
function calculateCartTotal(cart) {
  if (!cart || !cart.items || !Array.isArray(cart.items)) {
    return 0;
  }

  let total = 0;

  cart.items.forEach((item) => {
    const finalPrice = item.properties && item.properties["Final Price"];

    if (finalPrice) {
      const priceValue = parseFloat(finalPrice);

      if (!isNaN(priceValue)) {
        total += priceValue;
      }
    }
  });

  return Math.round(total * 100) / 100;
}

/**
 * Update cart total display elements with calculated total
 * @param {number} total - Total amount to display
 */
function updateCartTotalDisplay(total) {
  const totalElements = document.querySelectorAll(".total-price-id");
  totalElements.forEach((element) => {
    element.textContent = `¥${total.toLocaleString("ja-JP")}`;
  });
}

/**
 * Update final price display elements for individual cart items
 * @param {Object} cart - Shopify cart object
 */
function updateFinalPriceDisplays(cart) {
  if (!cart || !cart.items || !Array.isArray(cart.items)) {
    return;
  }

  cart.items.forEach((item, index) => {
    const finalPrice = item.properties && item.properties["Final Price"];
    let priceValue = 0; // Default to 0

    if (finalPrice) {
      const parsedPrice = parseFloat(finalPrice);
      if (!isNaN(parsedPrice)) {
        priceValue = parsedPrice;
      }
    }

    // Update all final-price elements for this item
    // Using item key or index to identify the specific item
    const finalPriceElements = document.querySelectorAll(
      `[data-item-key="${item.key}"] .final-price, .final-price[data-item-key="${item.key}"]`
    );

    // If no elements found with data-item-key, try to find by index or ID
    if (finalPriceElements.length === 0) {
      // Try to find by item index or generic final-price class
      const allFinalPriceElements = document.querySelectorAll(".final-price");
      if (allFinalPriceElements[index]) {
        allFinalPriceElements[
          index
        ].textContent = `¥${priceValue.toLocaleString("ja-JP")}`;
      }
    } else {
      finalPriceElements.forEach((element) => {
        element.textContent = `¥${priceValue.toLocaleString("ja-JP")}`;
      });
    }
  });
}

/**
 * Update a specific final price element by item key
 * @param {string} itemKey - The cart item key
 * @param {number} newPrice - The new price value
 */
function updateSingleFinalPrice(itemKey, newPrice) {
  if (!itemKey) {
    console.warn("Invalid itemKey provided to updateSingleFinalPrice");
    return;
  }

  // Default to 0 if newPrice is invalid
  const priceValue = isNaN(newPrice) ? 0 : newPrice;

  const finalPriceElements = document.querySelectorAll(
    `[data-item-key="${itemKey}"] .final-price, .final-price[data-item-key="${itemKey}"]`
  );

  finalPriceElements.forEach((element) => {
    element.textContent = `¥${priceValue.toLocaleString("ja-JP")}`;
  });

  // If no specific elements found, try to update by ID if it exists
  const finalPriceById = document.getElementById("final-price-id");
  if (finalPriceById && finalPriceElements.length === 0) {
    finalPriceById.textContent = `¥${priceValue.toLocaleString("ja-JP")}`;
  }
}

/**
 * Recalculate and update cart total
 */
async function refreshCartTotal() {
  try {
    const cartResponse = await fetch(window.Shopify.routes.root + "cart.js");

    if (!cartResponse.ok) {
      throw new Error(`HTTP error! status: ${cartResponse.status}`);
    }

    const cart = await cartResponse.json();

    const calculatedTotal = calculateCartTotal(cart);

    updateCartTotalDisplay(calculatedTotal);
    updateFinalPriceDisplays(cart);

    return calculatedTotal;
  } catch (error) {
    console.error("Error refreshing cart total:", error);
    return 0;
  }
}

/**
 * HTTP エラーの例外を作る。checkout_error に HTTP ステータスを数値で載せるため、status を持たせる。
 * @param {number} status - HTTP ステータス
 * @returns {Error}
 */
function createHttpError(status) {
  const httpError = new Error(`HTTP error! status: ${status}`);
  httpError.status = status;
  return httpError;
}

/**
 * /api/checkout が失敗したときの Error。
 * 価格を確かめられない明細があったとき（400 INVALID_CART_ITEMS。カートに入れた後で価格表が変わった場合など）は、
 * やり直しても通らないので、その商品名を入れた入れ直しの案内を userMessage に入れる
 * @param {Response} response - /api/checkout の応答
 * @param {Object} cartJson - 送った /cart.js の内容（明細の key から商品名を引く）
 * @returns {Promise<Error>}
 */
async function createCheckoutApiError(response, cartJson) {
  const error = createHttpError(response.status);
  const data = await response.json().catch(() => null);
  if (!data || data.code !== "INVALID_CART_ITEMS") {
    return error;
  }

  const invalidItems = Array.isArray(data.invalidItems) ? data.invalidItems : [];
  const invalidKeys = new Set(invalidItems.map((item) => item && item.key));
  const titles = (cartJson.items || [])
    .filter((item) => invalidKeys.has(item.key) && item.product_title)
    .map((item) => `「${item.product_title}」`);
  const target = titles.length > 0 ? titles.join("") : "カート内の商品";
  error.userMessage = `${target}の価格を確認できませんでした。お手数ですが、該当の商品をカートから削除し、商品ページからもう一度カートに入れてください。`;
  error.reason = invalidItems.map((item) => item && item.reason).join(",");
  return error;
}

/**
 * @param {Object} cartJson - /cart.js の内容（begin_checkout の計測と共有するため呼び出し元で取得する）
 */
async function getInvoiceUrl(cartJson) {
  // ログイン中はアクセストークンを Authorization ヘッダーで送り、バックエンドが下書き注文にお客様を紐付けられるようにする。
  // トークンが無い・読めないときは今までどおりヘッダー無しで進める（チェックアウトは止めない）。
  const readLoggedInAccessToken = () => {
    if (!window.isLogin) {
      return null;
    }
    try {
      const stored = JSON.parse(localStorage.getItem(window.customerAccessTokenKey));
      return stored && stored.accessToken ? stored.accessToken : null;
    } catch (error) {
      return null;
    }
  };
  const accessToken = readLoggedInAccessToken();
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
  };

  try {
    const response = await fetch(`${window.apiUrl}/api/checkout`, {
      method: "POST",
      body: JSON.stringify(cartJson),
      headers: headers,
    });

    if (!response.ok) {
      throw await createCheckoutApiError(response, cartJson);
    }

    const data = await response.json();
    return data.checkoutUrl;
  } catch (error) {
    console.error("Error getting invoice URL:", error);
    throw error;
  }
}

/**
 * Guard against navigating to a checkout URL the API did not actually return.
 * Without this, an empty or missing checkoutUrl silently reloads the cart or
 * lands the customer on a 404, with the loading overlay still covering it.
 * @param {unknown} url - The checkoutUrl returned by the checkout API
 * @returns {boolean} true when url is safe to navigate to
 */
function isUsableCheckoutUrl(url) {
  if (typeof url !== "string" || url.trim() === "") {
    return false;
  }

  try {
    const resolved = new URL(url, window.location.origin);
    return resolved.protocol === "https:" || resolved.protocol === "http:";
  } catch (error) {
    return false;
  }
}

/**
 * PostHog の begin_checkout / checkout_error に付けるチェックアウトの種類。
 * ログイン済みは member、未ログインでログイン画面へ向かうボタンは member_login、それ以外は guest。
 * @param {string} redirectUrl - handleCheckout に渡された遷移先
 * @returns {string}
 */
function getCheckoutType(redirectUrl) {
  if (window.isLogin) {
    return "member";
  }
  return redirectUrl && redirectUrl.trim() !== "" ? "member_login" : "guest";
}

/**
 * カートの明細プロパティの金額（create-checkout がサーバーで計算して入れた値）を数値で読む。
 * カートの表示・begin_checkout と同じく税込の金額。無い・数値でないときは null。
 * @param {Object} properties - カートの明細の properties
 * @param {string} name - "Price per Unit" または "Final Price"
 * @returns {number|null}
 */
function readCartItemPrice(properties, name) {
  const price = parseFloat(properties && properties[name]);
  return Number.isFinite(price) && price >= 0 ? price : null;
}

/**
 * order_complete（order-success ページ）用の購入明細を、決済に送ったカートの中身で作り直す。
 * カート追加時に退避した明細は、その後の削除や入れ直しを反映していないため、
 * 実際に /api/checkout へ送った明細を正とし、入稿方法・流入元だけを退避分から引き継ぐ。
 * 金額はカートの明細プロパティ（Price per Unit / Final Price、税込）を優先し、
 * 無い明細（サンプルなど）だけ退避分の単価を使う。
 * @param {Object} cart - /api/checkout に送った /cart.js の内容
 */
function stashPendingOrderFromCart(cart) {
  const STORAGE_KEY = "posthog_pending_order";
  try {
    const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "null");
    // 同じデザインを入れ直したときは新しい退避分を使うよう、後ろから探す
    const storedItems =
      stored && Array.isArray(stored.items) ? [...stored.items].reverse() : [];
    // 退避分の variant_id は "gid://shopify/ProductVariant/123" の形のことがあるので末尾の数字で比べる
    const toVariantNumber = (id) =>
      id == null ? "" : String(id).split("/").pop();

    const items = cart.items.map((cartItem) => {
      const designId =
        (cartItem.properties && cartItem.properties["Design Id"]) || null;
      const stashed =
        storedItems.find((item) =>
          designId
            ? String(item.design_id) === String(designId)
            : toVariantNumber(item.variant_id) === String(cartItem.variant_id)
        ) || {};
      const unitPriceIncludingTax = readCartItemPrice(
        cartItem.properties,
        "Price per Unit"
      );
      const lineTotalIncludingTax = readCartItemPrice(
        cartItem.properties,
        "Final Price"
      );

      return {
        ...stashed,
        product_id: cartItem.handle,
        product_name: stashed.product_name ?? cartItem.product_title,
        quantity: cartItem.quantity,
        // 税抜単価は overview-simulator と同じく税込を ÷1.1 した概算
        unit_price_excluding_tax:
          unitPriceIncludingTax != null
            ? Math.round(unitPriceIncludingTax / 1.1)
            : stashed.unit_price_excluding_tax ?? null,
        line_total_including_tax:
          lineTotalIncludingTax ?? stashed.line_total_including_tax ?? null,
        variant_id: cartItem.variant_id,
        design_id: designId,
      };
    });

    // checkout_started_at は、注文完了ページが「このタブで決済へ進んだ」ことを確かめる印
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ items: items, checkout_started_at: Date.now() })
    );
  } catch (error) {
    // プライベートモード等で sessionStorage が使えない場合は計測を諦める
  }
}

/**
 * 決済へ進んだ印（checkout_started_at）だけを消し、明細は残す。
 * カート画面がもう一度表示されたタブは、決済画面から店へ戻っている（決済をやめた）。
 * 決済を終えた人はカート画面を通らずに注文完了ページへ移るので、ここで消しても正規の計測は減らない。
 */
function clearCheckoutStartedMarker() {
  const STORAGE_KEY = "posthog_pending_order";
  try {
    const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "null");
    if (!stored || stored.checkout_started_at == null) {
      return;
    }
    const storedItems = Array.isArray(stored.items) ? stored.items : [];
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ items: storedItems }));
  } catch (error) {
    // sessionStorage が使えない場合は印も付いていないので、何もしない
  }
}

// 読み込んだとき（購入ボタンの処理が動く前）と、「戻る」でキャッシュから表示し直したときに消す
clearCheckoutStartedMarker();
window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    clearCheckoutStartedMarker();
  }
});

async function handleCheckout(redirectUrl) {
  showLoading("チェックアウト処理中...");
  const checkoutType = getCheckoutType(redirectUrl);
  let stage = "memo_save";

  const checkoutButtons = document.querySelectorAll(
    ".member-checkout, .guest-checkout, .mobile-member-checkout, .mobile-guest-checkout"
  );
  checkoutButtons.forEach((btn) => {
    // キーボード（Enter / Space）からの二重送信も防ぐため、disabled にする
    btn.disabled = true;
    btn.style.opacity = "0.7";
    btn.style.pointerEvents = "none";
    btn.innerHTML +=
      ' <span class="spinner-border spinner-border-sm ms-2" role="status"></span>';
  });

  try {
    const memoUpdateSuccess = await updateAllCustomerMemos();
    const hasRedirectUrl = Boolean(redirectUrl && redirectUrl.trim() !== "");
    // ログイン画面へ移る経路では、保存できなかったメモを後から補えないので、従来どおり止めてやり直してもらう
    if (!memoUpdateSuccess && hasRedirectUrl) {
      window.posthog?.capture?.("checkout_error", {
        stage: stage,
        checkout_type: checkoutType,
        status: null, // HTTP ステータスが無い場面も、status のキーは付ける
      });
      closeLoading();
      showToast(
        "メモの保存中にエラーが発生しました。もう一度お試しください。",
        "error"
      );
      restoreCheckoutButtons();
      return;
    }
    // 下書き注文へ進む経路では、メモは任意入力なので、保存に失敗しても決済は止めない。
    // 下書き注文には、この後 withDisplayedMemos で画面のメモを直接入れる。
    // 決済は止めないので、checkout_error とは別のイベントで記録する。
    if (!memoUpdateSuccess) {
      console.warn("handleCheckout: failed to save customer memos, continuing");
      window.posthog?.capture?.("checkout_warning", {
        stage: stage,
        checkout_type: checkoutType,
      });
    }

    // Only request a checkout URL when we actually need one. Callers that pass
    // a redirectUrl (the login button) never use it, and asking for it would
    // create a draft order that is immediately thrown away.
    if (hasRedirectUrl) {
      window.location.href = redirectUrl.trim();
      return;
    }

    stage = "cart_fetch";
    const cartResponse = await fetch(window.Shopify.routes.root + "cart.js");
    // 429・500 などは、checkout_error に HTTP ステータスが載るよう、ステータス付きの例外にする
    if (!cartResponse.ok) {
      throw createHttpError(cartResponse.status);
    }
    const savedCart = await cartResponse.json();
    const cart = withDisplayedMemos(savedCart);

    // 会員・ゲストのどちらで下書き注文の作成に進んだかと、カートの金額を記録する
    window.posthog?.capture?.(
      "begin_checkout",
      {
        checkout_type: checkoutType,
        currency: "JPY",
        value: calculateCartTotal(cart),
        detail_number: cart.items.length,
        total_quantity: cart.item_count,
      },
      { send_instantly: true }
    );

    stage = "draft_order";
    const invoiceUrl = await getInvoiceUrl(cart);
    if (!isUsableCheckoutUrl(invoiceUrl)) {
      console.error("handleCheckout: unusable checkout URL:", invoiceUrl);
      window.posthog?.capture?.("checkout_error", {
        stage: stage,
        checkout_type: checkoutType,
        message: "unusable checkout URL",
        status: null, // HTTP ステータスが無い場面も、status のキーは付ける
      });
      closeLoading();
      showToast(
        "チェックアウトの準備に失敗しました。もう一度お試しください。",
        "error"
      );
      restoreCheckoutButtons();
      return;
    }

    stashPendingOrderFromCart(cart);
    window.location.href = invoiceUrl;
  } catch (error) {
    console.error("handleCheckout failed:", error);
    window.posthog?.capture?.("checkout_error", {
      stage: stage,
      checkout_type: checkoutType,
      message: error.message,
      // HTTP ステータスが分かるとき（カートの取得・下書き注文 API のエラー）だけ数値、それ以外は null
      status: typeof error.status === "number" ? error.status : null,
      // 下書き注文 API が価格を確かめられなかった明細の理由（INVALID_CART_ITEMS のときだけ）
      reason: error.reason || null,
    });
    closeLoading();
    showToast(
      error.userMessage ||
        "チェックアウトの準備に失敗しました。もう一度お試しください。",
      "error"
    );
    restoreCheckoutButtons();
  }
}

function restoreCheckoutButtons() {
  const checkoutButtons = document.querySelectorAll(
    ".member-checkout, .guest-checkout, .mobile-member-checkout, .mobile-guest-checkout"
  );
  checkoutButtons.forEach((btn) => {
    btn.disabled = false;
    btn.style.opacity = "1";
    btn.style.pointerEvents = "auto";
    const spinner = btn.querySelector(".spinner-border");
    if (spinner) {
      spinner.remove();
    }
  });
}

document.addEventListener("DOMContentLoaded", async function () {
  await refreshCartTotal();
});

/**
 * Delete cart item using JavaScript instead of form submit
 * @param {string} itemKey - The cart item key to delete
 */
/**
 * Helper function to reload page with professional loading effect
 */
function reloadPageWithLoading() {
  showLoading("商品を削除中...");
  setTimeout(() => {
    closeLoading();
    setTimeout(() => location.reload(), 200);
  }, 800);
}

async function deleteCartItem(itemKey) {
  if (!itemKey || itemKey.toString().trim() === "") {
    console.error("Invalid item key provided to deleteCartItem");
    return false;
  }

  try {
    // Fetch latest cart data before deletion
    const cartResponse = await fetch(window.Shopify.routes.root + "cart.js");
    if (!cartResponse.ok) {
      throw new Error(`HTTP error! status: ${cartResponse.status}`);
    }

    const cart = await cartResponse.json();

    // Verify item still exists in cart
    const currentItem = cart.items.find((item) => item.key === itemKey);
    if (!currentItem) {
      console.warn("Item not found in cart with key:", itemKey);
      return true; // Item already deleted, consider as success
    }

    // Prepare delete request body using line item key
    const requestBody = {
      id: itemKey,
      quantity: 0,
    };

    const response = await fetch(
      window.Shopify.routes.root + "cart/change.js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      }
    );

    if (response.ok) {
      // Refresh cart total after successful deletion
      await refreshCartTotal();
      reloadPageWithLoading();
      return true;
    } else {
      console.error(
        "Failed to delete item:",
        response.status,
        response.statusText
      );
      reloadPageWithLoading();
      return false;
    }
  } catch (error) {
    console.error("Error deleting cart item:", error);
    reloadPageWithLoading();
    return false;
  }
}

// Function is available globally when script is loaded
